import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";

import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import DTU from "../../Assets/DTU.png";
import laptopImg from "../../Assets/abouttt.png";
import Toolstack from "./Toolstack";
import EducationCard from "./EducationCard";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              KNOW WHO <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "15%", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>


        <Row>
        <h1 style={{ fontSize: "2.1em", paddingBottom: "20px"}}>
              
            </h1>
        <Col>
        <h1 className="EducationCard" style={{ fontSize: "2.1em", paddingBottom: "40px"}} >
        <strong className="purple">EDU</strong>CATION
        </h1>
        <h1  >

        </h1>
        <img src={DTU} alt="about" className="img-fluid"style={{ float: "left",size:"40px",paddingLeft: "120px",paddingTop: "20px"}} />
       <br>
       </br>

       <h1 style={{ fontSize: "2.1em", paddingBottom: "8%"}}>
       <EducationCard /> 
              </h1>
       
        
        </Col>

        </Row>

        <h1 >
              <br>
              </br>
              </h1>

      
        <h1 className="project-heading">
          PROFESSIONAL <strong className="purple">SKILLSET </strong> 
        </h1>
        <br>
          </br>
        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">TOOLS </strong> I USE
        </h1>
        <br>
          </br>
        <Toolstack />

       
      
      </Container>
    </Container>
  );
}

export default About;
